import React from 'react';
import { styled } from 'styled-components';

const Input = styled.input`
  border: none;
  padding: 14px;
  width: 80%;
`;

export default Input;
